//Reducers
import dataReducer from './dataReducer';
import generalReducer from './generalReducer';


export default {
    general : generalReducer,
    data : dataReducer,
};